import React from 'react';
import { PlayCircle, Plus, GripVertical, FileText, X } from 'lucide-react';

interface SelectedModule {
  id: number;
  title: string;
  type: string;
  duration: string;
}

interface WebBasedCourseProps {
  selectedModules: SelectedModule[];
  onOpenModulesModal: () => void;
  onRemoveModule: (moduleId: number) => void;
}

const WebBasedCourse: React.FC<WebBasedCourseProps> = ({
  selectedModules,
  onOpenModulesModal,
  onRemoveModule,
}) => {
  return (
    <div className="trainer-coursemanagement-form-section">
      <div className="trainer-coursemanagement-section-header">
        <div className="trainer-coursemanagement-section-icon trainer-coursemanagement-orange">
          <PlayCircle size={24} color="white" />
        </div>
        <div>
          <h3>Course Modules ({selectedModules.length})</h3>
        </div>
        <button
          className="trainer-coursemanagement-add-offering-btn"
          onClick={onOpenModulesModal}
        >
          <Plus size={16} /> Add Modules
        </button>
      </div>

      {selectedModules.length === 0 ? (
        <div className="trainer-coursemanagement-empty-state">
          <div className="trainer-coursemanagement-empty-icon">
            <PlayCircle size={48} />
          </div>
          <p className="trainer-coursemanagement-empty-subtitle">
            No modules added yet. Click "Add Modules" to get started.
          </p>
        </div>
      ) : (
        <div className="trainer-coursemanagement-modules-list">
          {selectedModules.map((module, index) => (
            <div key={module.id} className="trainer-coursemanagement-module-item">
              <div className="trainer-coursemanagement-module-drag">
                <GripVertical size={20} />
              </div>
              <div className="trainer-coursemanagement-module-number">{index + 1}.</div>
              <div className="trainer-coursemanagement-module-icon">
                <FileText size={24} color="#FF8C00" />
              </div>
              <div className="trainer-coursemanagement-module-info">
                <p className="trainer-coursemanagement-module-title">{module.title}</p>
                <p className="trainer-coursemanagement-module-meta">
                  {module.type} • {module.duration}
                </p>
              </div>
              <button
                className="trainer-coursemanagement-icon-btn"
                onClick={() => onRemoveModule(module.id)}
              >
                <X size={18} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default WebBasedCourse;
